import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { PayoutListResponseType } from "@sellar-io/api-v2/types";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePayoutFromInvoiceId = <TData = PayoutListResponseType[number]>(
  invoiceId: number,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery<TData>({
    queryKey: [user?.uid, business?.id, ServerStateKeys.PayoutsFromInvoiceId],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `payout/from-invoice/${invoiceId}`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    placeholderData: (prev) => prev,
  });
};
